import * as React from "react"

import Img1 from "../../images/theme_1.svg"
import Img2 from "../../images/theme_2.svg"
import Img3 from "../../images/theme_3.svg"

export default function BackgroundTheme({ data }) {
  switch (data.backgroundTheme) {
    case "theme_1":
      return (
        <div className="absolute inset-x-0 top-[930px] overflow-hidden bottom-0 -z-[1]">
          <Img1 className="w-full" />
        </div>
      )

    case "theme_2":
      return (
        <div className="absolute inset-x-0 top-[350px] overflow-hidden bottom-0 -z-[1]">
          <Img2 className="w-full" />
        </div>
      )

    case "theme_3":
      return (
        <div className="absolute inset-x-0 top-[470px] overflow-hidden bottom-0 -z-[1]">
          <Img3 className="w-full" />
        </div>
      )

    default:
      return null
  }
}
